import { router } from '@/route/index.js'
import useUserStore from '@/store/userStore.js'
import eventBus from '@/utils/eventBus.js'
import { recoverDynamicImportFailure } from '@/utils/dynamicImportRecovery.js'

/**
 * 路由守卫初始化
 *
 * 功能说明：
 * - 路由权限验证（未登录跳转登录页）
 * - 页面加载进度条控制
 * - 动态组件加载失败处理
 */
const initialize = () => {
  /**
   * 全局前置守卫
   * - 开启页面加载进度条
   * - 验证用户登录状态
   */
  router.beforeEach(async (to) => {
    // 开启页面加载进度条
    eventBus.emit('progress:start')

    // 登录页无需验证
    let isToLogin = to.name === 'login'
    if (isToLogin) {
      return true
    }

    // 验证 token，未登录则跳转登录页
    const userStore = useUserStore()
    const token = userStore.getToken()
    if (!token) {
      return '/login'
    }
  })

  /**
   * 全局后置钩子
   * - 关闭页面加载进度条
   */
  router.afterEach(() => {
    // 完成页面加载进度条
    eventBus.emit('progress:done')
  })

  /**
   * 路由错误处理
   * - 处理动态组件加载失败的情况
   * - 关闭进度条并跳转 404 页面
   */
  router.onError((error) => {
    // 发生错误时也要关闭进度条
    eventBus.emit('progress:done')

    if (recoverDynamicImportFailure(error)) {
      console.error('动态组件加载失败:', error)
    }
  })
}

export default initialize
